<template>
  <div>
    <div
      class="w-32 h-32 p-4 -mt-12 mb-2 rounded-lg relative flex-no-shrink cursor-pointer"
      :class="[ color ? color : 'bg-blue' ]"
      @click="iconPickerVisible = true"
    >
      <div class="absolute pin-t pin-r bg-white -mt-3 -mr-3 rounded-full border h-8 w-8 flex justify-center items-center">
        <i class="far fa-edit fa-fw" />
      </div>

      <!-- <i v-if="icon" class="fas fa-5x text-white" :class="`fa-${icon}`"></i> -->
      <icon v-if="icon" :name="icon" :class="icon_text_color"></icon>

      <span v-else class="absolute pin-x pin-b mb-4 px-3 text-white text-center text-xs font-medium">
        Click to choose an icon
      </span>
    </div>

    <modal
      v-if="iconPickerVisible"
      :scrollY="false"
    >
      <icon-picker :canPickColor="canPickColor" :canPickTextIcon="canPickTextIcon" />
    </modal>
  </div>
</template>

<script>
import IconPicker from '@/components/IconPicker'
import { EventBus } from '@/EventBus'

export default {
  components: { IconPicker },

  props: {
    icon: String,
    color: String,
    icon_text_color: String,
    canPickColor: { default: true },
    canPickTextIcon: { default: true }
  },

  data () {
    return {
      iconPickerVisible: false
    }
  },

  methods: {
    saved (data) {
      if (this.iconPickerVisible) {
        this.iconPickerVisible = false
        this.$emit('change', data)
      }
    },

    cancelled () {
      this.iconPickerVisible = false
    }
  },

  created () {
    EventBus.$on('icon-picker:cancel', this.cancelled)
    EventBus.$on('icon-picker:saved', this.saved)
  },

  beforeDestroy () {
    EventBus.$off('icon-picker:cancel', this.cancelled)
    EventBus.$off('icon-picker:saved', this.saved)
  }
}
</script>
